export const boardCoreTour = {
  key: "boardCore",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-sidemenus"]',
      content: t("Tour_BoardCore_SideMenus"),
      placement: "right",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-topmenu"]',
      content: t("Tour_BoardCore_TopMenu"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-viewswitcher-tabs"]',
      content: t("Tour_BoardCore_ViewSwitcher"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-addtask"]',
      content: t("Tour_BoardCore_AddTask"),
      placement: "left",
    },
    {
      target: '[data-tour="board-chat-icon"]',
      content: t("Tour_BoardCore_ChatIcon"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-members-icon"]',
      content: t("Tour_BoardCore_MembersIcon"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-settings-icon"]',
      content: t("Tour_BoardCore_SettingsIcon"),
      placement: "bottom",
    },
    {
      target: '[data-tour="help-button"]',
      content: t("Tour_HelpButtonHint"),
      placement: "bottom",
    },
  ],
};
